// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__pMZ0k","spinner":"LoadingSpinner_spinner__F+0jw","spin":"LoadingSpinner_spin__25h8M"};